<script>
    export let selected = false;
    export let title = "";
    export let css_class;
</script>

<span class:selected class="{css_class}" {title} on:click><slot/></span>